import { render, staticRenderFns } from "./CurrencyPreference.vue?vue&type=template&id=85f65adc"
import script from "./CurrencyPreference.vue?vue&type=script&lang=js"
export * from "./CurrencyPreference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports